import React from "react"
import { Box, Paper, Stack, Typography } from "@mui/material"
import SideBarLayout from "../../../layout/side-bar-layout"
import { TITLE_DESIGN_SYSTEM_PAGE } from "../../../../utils/constants"
import StatusIconBadge from "src/v2/components/StatusIconBadge"
import CodeViewer from "../../../components/CodeViewer/code-viewer"
import { ReactComponent as CheckIcon } from "src/v2/assets/icons/check-icon.svg"
import { ReactComponent as WarningIcon } from "src/v2/assets/icons/warning-error-icon.svg"

const StatusIconBadgeDesignSystemPage = () => {
    const TITLE_PAGE = `${TITLE_DESIGN_SYSTEM_PAGE} | Status Icon Badge`

    const codeUsage = `import StatusIconBadge from "src/v2/components/StatusIconBadge"
import { ReactComponent as CheckIcon } from "src/assets/icons/check-icon.svg"
import { ReactComponent as WarningIcon } from "src/assets/icons/warning-icon.svg"

// Uso Básico (Texto e Ícone da mesma cor)
<StatusIconBadge 
    label="CADASTRO EM ANDAMENTO" 
    color="warning" 
    icon={<WarningIcon />} 
/>

// Cores Distintas (Texto Branco, Ícone Amarelo)
<StatusIconBadge 
    label="CADASTRO EM PRODUÇÃO" 
    color="white" 
    iconColor="warning" 
    icon={<CheckIcon />} 
/>`

    const codeProps = `type StatusIconBadgeProps = {
  label: string,          // Texto exibido
  icon: ReactNode,        // Componente de ícone (SVG)
  color?: string,         // Cor base do texto e do ícone (se iconColor não for passado)
  iconColor?: string      // (Opcional) Cor específica para o ícone, sobrescrevendo 'color'
}`

    return (
        <SideBarLayout
            header
            title={TITLE_PAGE}
            headerTitle={TITLE_PAGE}
        >
            <Box sx={{ mt: -2 }}>
                <Stack spacing={3}>
                    <Paper>
                        <Box p={3}>
                            <Typography variant="h4" gutterBottom color="common.white">
                                {`StatusIconBadge`}
                            </Typography>
                            <Typography variant="body2" color="text.secondary">
                                {`Badge que combina um ícone e um texto para sinalizar estados de forma mais visual. 
                                Permite colorir o ícone independentemente do texto, alternativa ao componente StatusBadge.`}
                            </Typography>

                            <Stack direction="row" spacing={4} flexWrap="wrap" mt={4} alignItems="center">
                                <StatusIconBadge 
                                    label="CADASTRO EM ANDAMENTO" 
                                    color="warning" 
                                    icon={<WarningIcon />} 
                                />

                                <Box sx={{  p: 1, borderRadius: 1 }}>
                                    <StatusIconBadge 
                                        label="CADASTRO EM PRODUÇÃO" 
                                        color="white" 
                                        iconColor="warning"
                                        icon={<CheckIcon />} 
                                    />
                                </Box>

                            </Stack>
                        </Box>
                    </Paper>

                    <Paper>
                        <Box p={3}>
                            <Typography variant="h6" gutterBottom color="common.white">
                                {`Uso básico`}
                            </Typography>
                            <Typography variant="body2" color="text.secondary" paragraph>
                                {`Utilize a prop 'iconColor' quando precisar destacar o ícone com uma cor diferente do texto (ex: fundo escuro com texto claro e ícone de alerta).`}
                            </Typography>

                            <Paper variant="outlined">
                                <Box p={2}>
                                    <CodeViewer code={codeUsage} language="jsx" />
                                </Box>
                            </Paper>
                        </Box>
                    </Paper>

                    <Paper>
                        <Box p={3}>
                            <Typography variant="h6" gutterBottom color="common.white">
                                {`Propriedades principais`}
                            </Typography>
                            <Typography variant="body2" color="text.secondary" paragraph>
                                {`Interface do componente.`}
                            </Typography>

                            <Paper variant="outlined">
                                <Box p={2}>
                                    <CodeViewer code={codeProps} language="tsx" />
                                </Box>
                            </Paper>
                        </Box>
                    </Paper>
                </Stack>
            </Box>
        </SideBarLayout>
    )
}

export default StatusIconBadgeDesignSystemPage
